<li class="listItem">
  <div class="left">
    <div class="imageWrapper">
      <img [src]="image" [alt]="name" class="image">
    </div>
    <div class="priceTime">
      <div class="name">{{name}}</div>
      <div class="time">
        {{paid ? showISOStringToDateAndTime(timeProp) : '未付款'}}
      </div>
    </div>
  </div>
  <div class="right">
    $ {{price}}
  </div>
</li>